import {
  DefaultError,
  ErrorComponentType,
} from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { useEffect, useState } from "react";
import { Text } from "shared/components/Spor";

export type TrainmapErrorComponentType = {
  refreshParent: () => void;
};

export const TrainmapErrorComponent: ErrorComponentType<
  TrainmapErrorComponentType
> = ({ error, resetState, refreshParent }) => {
  const [shouldRefreshParent, setShouldRefreshParent] = useState(false);

  useEffect(() => {
    if (shouldRefreshParent) {
      // Workaround for the useWebsocket hook not handling topic changes.
      // It throws an error if swapping topics on a live connection, which
      // renders an error and unmounts the component. This clears the connection,
      // so we can force a rerender and clear the error state from the boundary
      // to mount the map and hook anew, to create a new connection instead
      resetState();
      setShouldRefreshParent(false);
      refreshParent();
    }
  }, [refreshParent, shouldRefreshParent, resetState]);

  useEffect(() => {
    if (
      error?.message?.includes(
        "Attempted to change subscribed websocket topics after mount.",
      )
    ) {
      setShouldRefreshParent(true);
      log(
        LogLevel.error,
        "TrainMap",
        "TrainMap crashed due to switching websocket topics and had to be refreshed",
        error,
      );
    }
  }, [error]);

  if (
    error?.message?.includes(
      "Attempted to change subscribed websocket topics after mount.",
    )
  ) {
    return <Text>Laster togkart ...</Text>;
  }

  return <DefaultError />;
};
